import "core-js/modules/es.array.reverse.js";
var _class, _descriptor, _GeoJsonParameter;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { computed, makeObservable, observable } from "mobx";
import FunctionParameter from "./FunctionParameter";
import LineParameter from "./LineParameter";
import PointParameter from "./PointParameter";
import PolygonParameter from "./PolygonParameter";
import SelectAPolygonParameter from "./SelectAPolygonParameter";
export function isGeoJsonFunctionParameter(fp) {
  return [PointParameter.type, LineParameter.type, PolygonParameter.type, GeoJsonParameter.type].includes(fp.type);
}
let GeoJsonParameter = (_class = (_GeoJsonParameter = class GeoJsonParameter extends FunctionParameter {
  constructor(catalogFunction, options) {
    super(catalogFunction, options);
    _defineProperty(this, "type", "geojson");
    _initializerDefineProperty(this, "subtype", _descriptor, this);
    _defineProperty(this, "regionParameter", void 0);
    makeObservable(this);
    this.regionParameter = options.regionParameter;
  }

  /**
   * Return representation of value as URL argument.
   */
  getProcessedValue(value) {
    if (this.subtype === GeoJsonParameter.PointType) {
      return {
        inputType: "ComplexData",
        inputValue: PointParameter.formatValueForUrl(value)
      };
    }
    if (this.subtype === GeoJsonParameter.PolygonType) {
      return {
        inputType: "ComplexData",
        inputValue: PolygonParameter.formatValueForUrl(value)
      };
    }
    if (this.subtype === GeoJsonParameter.SelectAPolygonType) {
      return {
        inputType: "ComplexData",
        inputValue: SelectAPolygonParameter.formatValueForUrl(value)
      };
    }
  }
  get geoJsonFeature() {
    if (this.subtype === GeoJsonParameter.PointType) {
      return PointParameter.getGeoJsonFeature(this.value);
    }
    if (this.subtype === GeoJsonParameter.PolygonType) {
      return PolygonParameter.getGeoJsonFeature(this.value);
    }
    if (this.subtype === GeoJsonParameter.SelectAPolygonType) {
      return SelectAPolygonParameter.getGeoJsonFeature(this.value);
    }
    return;
    // TODO rest
  }
}, _defineProperty(_GeoJsonParameter, "type", "geojson"), _defineProperty(_GeoJsonParameter, "PointType", "point"), _defineProperty(_GeoJsonParameter, "PolygonType", "polygon"), _defineProperty(_GeoJsonParameter, "RegionType", "region"), _defineProperty(_GeoJsonParameter, "SelectAPolygonType", "selectAPolygon"), _GeoJsonParameter), _descriptor = _applyDecoratedDescriptor(_class.prototype, "subtype", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "geoJsonFeature", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "geoJsonFeature"), _class.prototype), _class);
export { GeoJsonParameter as default };